import { render, staticRenderFns } from "./goodsLabelArchLifes.vue?vue&type=template&id=16afe60e&scoped=true&"
import script from "./goodsLabelArchLifes.vue?vue&type=script&lang=js&"
export * from "./goodsLabelArchLifes.vue?vue&type=script&lang=js&"
import style0 from "./goodsLabelArchLifes.vue?vue&type=style&index=0&id=16afe60e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16afe60e",
  null
  
)

component.options.__file = "goodsLabelArchLifes.vue"
export default component.exports